(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["peak-product-support"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('peak-optician-chat')) {
  customElements.define('peak-optician-chat', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('button').addEventListener('click', async () => {
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        status.hidden = true;
        button.disabled = true;
        let attempts = 0;
        const openChat = () => {
          if (!this.isConnected) return;
          const chat = document.querySelector('shopify-chat');
          if (chat && typeof chat.show === 'function') {
            chat.show();
            button.disabled = false;
          } else if (++attempts < 32) {
            window.setTimeout(openChat, 250);
          } else {
            button.disabled = false;
            status.hidden = false;
          }
        };
        openChat();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
